export const allAboutDates = {
    methods: {
        dateToNiceStr(date){       
            let nice = date.slice(0, 10)
            let dd   = nice.slice(8, 10)
            let mm   = nice.slice(5, 7)
            let yyyy = nice.slice(0, 4)

            nice = dd + " / " + mm + " / " + yyyy

            return nice
        },
        joursFeries(an, isAlsace){
            //Jours fixes
            let JourAn = new Date(an, "00", "01")
            let FeteTravail = new Date(an, "04", "01")
            let Victoire1945 = new Date(an, "04", "08")
            let FeteNationale = new Date(an,"06", "14")
            let Assomption = new Date(an, "07", "15")
            let Toussaint = new Date(an, "10", "01")
            let Armistice = new Date(an, "10", "11")
            let Noel = new Date(an, "11", "25")
            
            //jours mobiles
            let G = an%19
            let C = Math.floor(an/100)
            let H = (C - Math.floor(C/4) - Math.floor((8*C+13)/25) + 19*G + 15)%30
            let I = H - Math.floor(H/28)*(1 - Math.floor(H/28)*Math.floor(29/(H + 1))*Math.floor((21 - G)/11))
            let J = (an*1 + Math.floor(an/4) + I + 2 - C + Math.floor(C/4))%7
            let L = I - J
            let MoisPaques = 3 + Math.floor((L + 40)/44)
            let JourPaques = L + 28 - 31*Math.floor(MoisPaques/4)
            // let Paques = new Date(an, MoisPaques-1, JourPaques)
            let LundiPaques = new Date(an, MoisPaques-1, JourPaques+1)
            let Ascension = new Date(an, MoisPaques-1, JourPaques+39)
            // let Pentecote = new Date(an, MoisPaques-1, JourPaques+49)
            let LundiPentecote = new Date(an, MoisPaques-1, JourPaques+50)

            //Synthèse
            let synth = new Array(JourAn, LundiPaques, FeteTravail, Victoire1945, Ascension, LundiPentecote, FeteNationale, Assomption, Toussaint, Armistice, Noel)

            //Ajout des jours fériés personnalisés pour l'agence
            if (isAlsace){
                let SaintEtienne = new Date(an, "11", "26")
                let VendrediSaint = new Date(an, MoisPaques-1, JourPaques-2)
                synth.push(SaintEtienne);
                synth.push(VendrediSaint);
            }

            return synth
        },
        joursOuvres(an, isAlsace){
            let day = new Date(an, 0, 1) // 1er (jour "1") Janvier (mois"0") de l'année "an"
            let arrayFeries = this.joursFeries(an, isAlsace)
            let compteurOuvres = 0

            for (day; day.getFullYear() == an; day.setDate(day.getDate() + 1)){
                if (!arrayFeries.find(e => (e.getDate() == day.getDate() && e.getMonth() == day.getMonth()))){ //J'évite les jours fériés
                    if (day.getDay() !== 0 && day.getDay() !== 6){ //J'évite les samedi (6) et les dimanches (0)
                        compteurOuvres ++
                    }
                }
            }

            return compteurOuvres
        },
        HTMLDateToDate(HTMLDate){
            let dd   = HTMLDate.slice(8, 10)
            let mm   = HTMLDate.slice(5, 7)
            let yyyy = HTMLDate.slice(0, 4)

            let date = new Date (yyyy, mm - 1, dd, 1, 0, 0, 0)

            return date
        }
    }
}